function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20346"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 4561",
    style: {
      fill: "#fff",
      stroke: "#e0e0df",
      strokeWidth: ".5px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 168,
    rx: 10,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 167.5,
    height: 167.5,
    rx: 9.75,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.75 20.25h-18v-18a2.25 2.25 0 0 0-4.5 0v18h-18a2.25 2.25 0 0 0 0 4.5h18v18a2.25 2.25 0 1 0 4.5 0v-18h18a2.25 2.25 0 1 0 0-4.5zm0 0",
    transform: "translate(62 62)",
    style: {
      fill: "#7c7c7c",
      stroke: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImg);
export default __webpack_public_path__ + "static/media/add-img.0e0006de61c9036214e2dd551af02a3c.svg";
export { ForwardRef as ReactComponent };